import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { CustomerService } from '../../services/customer.service';
import { GTM } from 'src/app/services/gtm.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HbmApiService } from 'src/app/services/hbm/hbm-api.service';
import { DatasService } from 'src/app/services/datas.service';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

interface ConfiguratorPreview {
  src: string;
  alt: string;
}

@Component({
  selector: 'ng-casto-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  protected readonly faCheckCircle = faCheckCircle;
  protected readonly faTimes = faTimes;

  loginCallBack: Function;

  /**
   * URL rejouée au retour d'AuthApp. Sans elle, le client revient sur la page courante : un
   * projet ne se démarre qu'une fois connecté, il n'y a donc plus de configuration à perdre.
   */
  private returnUrl: string;

  constructor(
    public modalService: ModalService,
    private readonly customer: CustomerService,
    private readonly gtm: GTM,
    private readonly router: Router,
    private readonly hbmService: HbmApiService,
    private readonly datas: DatasService
  ) {}

  /** Aperçus de l'encart bleu, limités aux configurateurs ouverts sur ce site. */
  get configuratorPreviews(): ConfiguratorPreview[] {
    return [
      { enabled: this.datas.kitchenEnabled, src: 'assets/img/home/kitchen.png?v=2', alt: 'Cuisine' },
      { enabled: this.datas.storageEnabled, src: 'assets/img/home/dressing.jpg?v=3', alt: 'Rangement' },
      { enabled: this.datas.bathroomEnabled, src: 'assets/img/home/bathroom.jpg?v=3', alt: 'Salle de bain' },
    ]
      .filter(preview => preview.enabled)
      .map(({ src, alt }) => ({ src, alt }));
  }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/se-connecter`, 'Se connecter');
    if (this.modalService.currentDatas) {
      this.loginCallBack = this.modalService.currentDatas.loginCallBack;
      this.returnUrl = this.modalService.currentDatas.returnUrl;
    }

    // fake login
    if (environment.configurators2d.global.debug.fakeCustomer) {
      this.customer.userDatas = environment.configurators2d.global.debug.data.customer;
      this.hbmService.acquireTokenWS(this.customer.userDatas.id, 'token').then(() => {
        if (this.loginCallBack) {
          this.loginCallBack();
        } else {
          this.modalService.close();
        }
      });
    }
  }

  close(): void {
    this.modalService.close();
  }

  /**
   * L'inscription part directement sur AuthApp : c'est lui qui détient les credentials. Les
   * coordonnées sont réclamées au retour par la popup de complétion, ce qui évite de saisir
   * un formulaire avant de savoir si le compte peut être créé.
   */
  subscribe(): void {
    this.gtm.trackEvent('s-enregistrer');
    this.customer.signup(this.returnUrl);
  }

  submit(): void {
    this.gtm.trackEvent('se-connecter');
    this.customer.login(this.returnUrl);
  }
}
